import Cookies from 'js-cookie';
import { IGetMasterDataPayload } from '../types/apiTypes';
import { ENDPOINTS } from './endpoints';
import { getChannelId } from './headerUtils';

export const extractDomain = (): string => {
  if (typeof window === "undefined") return "";

  const currentOrigin = window.location.origin;

  if (
    currentOrigin.includes("localhost:3000") ||
    currentOrigin.includes("test")
  ) {
    return "https://recruiter.foundit.in";
  }

  return currentOrigin;
};

export const getDomainName = (hostname: string) => {
  let newDomainName = hostname?.replace(/^recruiter\./, "");
  if (hostname === "localhost") {
    newDomainName = "foundit.in";
  }
  return newDomainName;
};

export function extractBaseServer(url: string) {
  if (url.includes("localhost") || url.includes("test")) {
    url = "recruiter.foundit.in";
  }

  const parts = url.split(".");
  const domain = parts[parts.length - 2] + "." + parts[parts.length - 1];

  return domain;
}

export function extractBaseServerV2(url: string) {
  if (url.includes("localhost") || url.includes("test")) {
    url = "recruiter.foundit.in";
  }

  const parts = url.split(".");
  let domain = parts[parts.length - 2] + "." + parts[parts.length - 1];
   if( parts[parts.length-3] && parts[parts.length-3] !== "recruiter" ){
      domain = parts[parts.length-3] + "." + domain;
    }


  return domain;
}

// clear session and cookies
export const clearSessionAndCookieItem = (key:any) => {
    sessionStorage.removeItem(key);
    // delete cookie
    Cookies.remove(key, { path: '/' })
}

export const API_HEADERS = {
  domain: extractDomain(),
};

export const MIDDLEWARE = "/edge/recruiter-dashboard/api/dashboard-middleware";

export const fetchMasterData = async ({
  channelId,
  subChannelId,
  middleware,
  version
}: IGetMasterDataPayload) => {
    const finalChannelId = typeof channelId === "number" ? channelId : getChannelId(channelId || "");
    const baseServer = extractBaseServerV2(window.location.host);
    const domain = extractDomain();
    let masterDataUrl = `${middleware || MIDDLEWARE}${
      ENDPOINTS.getMasterData
    }?channelId=${finalChannelId}`;
    if(subChannelId){
      masterDataUrl+=`&subChannelId=${subChannelId}`
    }

    const response = await fetch(masterDataUrl, {
      method: "GET",
      headers: {
        ...API_HEADERS,
        baseserver: baseServer,
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const masterData = await response.json();

    const dataToStore = {
      ...masterData,
      storeTime: Date.now(), 
      version
    };

    localStorage.setItem(`master-data-${channelId}`, JSON.stringify(dataToStore));

    return masterData;
};




